import $ from 'jquery';

let unpublishButton  = $('.js-unpublish-button');
let popup = $('.js-modal');
let cancelButton =  popup.find('.cancel-button');

if (unpublishButton) {
    unpublishButton.on('click', function (){
        popup.addClass('active');
    })

    if (cancelButton) {
        cancelButton.on('click', function () {console.log('aaaaa')
            popup.removeClass('active')
        });
    }
}